// eslint-disable-next-line no-restricted-imports
import { H2 } from 'dripsy';

export default H2;
